import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { createThread as create } from "../features/messageThreads/createThread"
import { useCallback, useContext, useState } from "react"
import { viewContext } from "../context/viewContext"
import { fetchMessages } from "../features/messages/fetchMessages"

export const useFetchMessages = ({ thread_id, page, per_page }) => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()
  const owner = useSelector(state => state.owners[unique_owner_id])

  const [fetchedPage, setFetchedPage] = useState(null)

  const status = owner?.actionStatuses?.fetchMessages?.status
  const loaded = owner?.actionStatuses?.fetchMessages?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const fetch = useCallback(async () => {
    await dispatch(fetchMessages({ thread_id, page, unique_owner_id, per_page }))
    setFetchedPage(page)
  }, [dispatch, thread_id, page, unique_owner_id, per_page])
  
  return {
    isFetching,
    isLoading,
    isSuccess,
    error,
    fetch,
    fetchedPage
  }
}
